/* XION • smooth-scroll.js
   Lenis smooth scrolling. Disabled under prefers-reduced-motion (native scroll takes over).
   Works with the theme's IntersectionObserver animations (they read the real scroll
   position, which Lenis updates) and auto-syncs with GSAP ScrollTrigger if it is present. */
(function () {
  'use strict';

  // 7) Respect reduced motion — do not initialize Lenis; let native scrolling handle it.
  var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (mq && mq.matches) { return; }

  // Skip smooth scroll on touch / small screens. Native momentum scrolling is already
  // smooth there, and Lenis's rAF interpolation fights it — producing visible judder
  // ("shaking") while scrolling on mobile. Desktop (fine pointer, wider screens) keeps
  // smooth scrolling.
  var coarsePointer = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
  var smallScreen = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
  if (coarsePointer || smallScreen) { return; }

  // If the CDN failed to load, fall back to native scroll silently.
  if (typeof Lenis === 'undefined') { return; }

  // 3) Initialize Lenis
  var lenis = new Lenis({
    lerp: 0.1,
    duration: 1.2,
    smoothWheel: true,
    wheelMultiplier: 1
  });
  window.lenis = lenis; // exposed for debugging / other scripts

  // 5) Sync with GSAP ScrollTrigger when GSAP is present (no-op on this theme — it uses IO).
  if (window.gsap && window.gsap.ticker && window.ScrollTrigger) {
    lenis.on('scroll', window.ScrollTrigger.update);
    window.gsap.ticker.add(function (time) { lenis.raf(time * 1000); });
    window.gsap.ticker.lagSmoothing(0);
  } else {
    // 4) Standard requestAnimationFrame loop drives Lenis.
    //    IntersectionObserver-based entrance animations need no changes: Lenis scrolls the
    //    window natively, so element positions and IO callbacks stay accurate.
    var raf = function (time) { lenis.raf(time); requestAnimationFrame(raf); };
    requestAnimationFrame(raf);
  }

  // Sticky-header offset so an anchored target isn't hidden behind the fixed header.
  function headerOffset() {
    var v = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10);
    if (!isNaN(v) && v > 0) { return v; }
    var h = document.querySelector('store-header, .header, header');
    return h ? h.offsetHeight : 0;
  }

  // 6) Make same-page anchor links use Lenis smooth scroll.
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest ? e.target.closest('a[href*="#"]') : null;
    if (!link || link.hasAttribute('data-lenis-skip')) { return; }
    var url = link.getAttribute('href') || '';
    var hashIndex = url.indexOf('#');
    if (hashIndex === -1) { return; }
    var path = url.slice(0, hashIndex);
    // Only intercept in-page anchors; let cross-page links navigate normally.
    if (path && path !== window.location.pathname && path !== './') { return; }
    var id = url.slice(hashIndex);
    if (id.length < 2) { return; }
    var target;
    try { target = document.querySelector(id); } catch (err) { return; }
    if (!target) { return; }
    e.preventDefault();
    lenis.scrollTo(target, { offset: -(headerOffset() + 12) });
    if (history.replaceState) { history.replaceState(null, '', id); }
  });
})();
